/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_contact_fields_order_id = /** @type {(inputs: {}) => string} */ () => {
	return `Číslo objednávky`
};

const da_contact_fields_order_id = /** @type {(inputs: {}) => string} */ () => {
	return `Ordrenummer`
};

const de_contact_fields_order_id = /** @type {(inputs: {}) => string} */ () => {
	return `Bestellnummer`
};

const en_contact_fields_order_id = /** @type {(inputs: {}) => string} */ () => {
	return `Order number`
};

const es_contact_fields_order_id = /** @type {(inputs: {}) => string} */ () => {
	return `Número de pedido`
};

const fr_contact_fields_order_id = /** @type {(inputs: {}) => string} */ () => {
	return `Numéro de commande`
};

const hu_contact_fields_order_id = /** @type {(inputs: {}) => string} */ () => {
	return `Rendelés száma`
};

const it_contact_fields_order_id = /** @type {(inputs: {}) => string} */ () => {
	return `Numero ordine`
};

const nl_contact_fields_order_id = /** @type {(inputs: {}) => string} */ () => {
	return `Bestelnummer`
};

const pl_contact_fields_order_id = /** @type {(inputs: {}) => string} */ () => {
	return `Numer zamówienia`
};

const pt_contact_fields_order_id = /** @type {(inputs: {}) => string} */ () => {
	return `Número do pedido`
};

const sv_contact_fields_order_id = /** @type {(inputs: {}) => string} */ () => {
	return `Ordernummer`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const contact_fields_order_id = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.contact_fields_order_id(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("contact_fields_order_id", locale)
	if (locale === "cs") return cs_contact_fields_order_id(inputs)
	if (locale === "da") return da_contact_fields_order_id(inputs)
	if (locale === "de") return de_contact_fields_order_id(inputs)
	if (locale === "en") return en_contact_fields_order_id(inputs)
	if (locale === "es") return es_contact_fields_order_id(inputs)
	if (locale === "fr") return fr_contact_fields_order_id(inputs)
	if (locale === "hu") return hu_contact_fields_order_id(inputs)
	if (locale === "it") return it_contact_fields_order_id(inputs)
	if (locale === "nl") return nl_contact_fields_order_id(inputs)
	if (locale === "pl") return pl_contact_fields_order_id(inputs)
	if (locale === "pt") return pt_contact_fields_order_id(inputs)
	return sv_contact_fields_order_id(inputs)
};
export { contact_fields_order_id as "contact.fields.order_id" }